var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-dialog',{on:{"close":_vm.back}},[_c('button',{on:{"click":_vm.asyncAlert}},[_vm._v("asyncAlert")]),_c('dl',[_c('dt',[_vm._v("Session")]),_c('dd',[_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.session, undefined, 2)))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }